module.exports = new __parcel__URL__("shackleoflight.0dd43e93.png").toString();